import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeHoliday, getAllHolidays } from "../../../actions/holidayActions";
const DeleteHoliday = ({ showDeleteDropDown, openDeleteDropDown, current }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [dataUpdate, setDataUpdate] = useState({
    _id: current.id,
    delete: true,
    // disable: true,
  });
  // console.log("delete mein current", current, showDeleteDropDown, openDeleteDropDown)
  const valueUpdate = () => {
    if (current !== undefined) {
      setDataUpdate({
        _id: current.id,
        delete: true,
        // disable: true,
      });
    }
    // console.log(dataUpdate, "dataUpdate")
  };
  useEffect(() => {
    valueUpdate();
    // console.log(dataUpdate, "dataUpdate")
  }, [current]);
  const allUsersData = async () => {
    dispatch(getAllHolidays({ companyId: auth.user.companyId }));
    // dispatch(getActiveUsers({companyId: auth.user.companyId}, 1))
    // dispatch(getDisabledUsers({companyId: auth.user.companyId}, 1))
  };
  const handleSubmit = async () => {
    dispatch(removeHoliday(dataUpdate));
    openDeleteDropDown();
    setTimeout(() => allUsersData(), 1000);
  };
  return (
    <>
      <div
        className={`modal-backdrop fade ${
          showDeleteDropDown ? "show" : "hide"
        }`}
      ></div>
      <div
        className={`modal custom-modal fade ${
          showDeleteDropDown ? "show" : "hide"
        }`}
        id="delete_warn"
        role="dialog"
        onClick={(e) => {
          // Check if the click occurred outside the modal content
          if (e.target === e.currentTarget) {
            openDeleteDropDown(); // Call your close modal function
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>Delete Holiday</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                    <a
                      className="btn btn-primary continue-btn"
                      onClick={handleSubmit}
                    >
                      Delete
                    </a>
                  </div>
                  <div className="col-6">
                    <a
                      data-dismiss="modal"
                      className="btn btn-primary cancel-btn"
                      onClick={() => openDeleteDropDown()}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DeleteHoliday;
